import TrainerUtilities from '../trainer/trainer';
import gamePreviewMixin from '../trainer/gamePreviewMixin';

export default {
    mixins: [TrainerUtilities, gamePreviewMixin],
    computed: {
        onlyMultOrDivChosen() {
            return (
                (this.chosenOperations.includes('×') || this.chosenOperations.includes('÷')) &&
                !(this.chosenOperations.includes('+') || this.chosenOperations.includes('-'))
            );
        },
        onlyDivChosen() {
            return (
                this.chosenOperations.includes('÷') &&
                !(
                    this.chosenOperations.includes('+') ||
                    this.chosenOperations.includes('-') ||
                    this.chosenOperations.includes('×')
                )
            );
        },
        isMultDivLeftCombiningEnabled() {
            return this.settings.multDivDigitCapacity.left.length > 1;
        },
        isMultDivRightCombiningEnabled() {
            return this.settings.multDivDigitCapacity.right.length > 1;
        },
        MultDivLeftHighestCapacity() {
            return Math.max(...this.settings.multDivDigitCapacity.left);
        },
        MultDivRightHighestCapacity() {
            return Math.max(...this.settings.multDivDigitCapacity.right);
        },
        chosenOperations() {
            let operations = [];
            if (this.settings.operations.add) {
                operations.push('+');
            }
            if (this.settings.operations.subtract) {
                operations.push('-');
            }
            if (this.settings.operations.multiply) {
                operations.push('×');
            }
            if (this.settings.operations.divide) {
                operations.push('÷');
            }
            return operations;
        },
    },
};
